import React from "react";

export default function Airplane({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17.998"
      viewBox="0 0 18 17.998"
      className={color}
    >
      <g id="airplane" transform="translate(0 -1.002)">
        <g id="Group_333" dataname="Group 333" transform="translate(0 1.002)">
          <path
            id="Path_141"
            dataname="Path 141"
            d="M17.311,1.688h0a2.348,2.348,0,0,0-3.318,0L11.167,4.495,1.78,1.813a.783.783,0,0,0-.768.2l-.783.783a.783.783,0,0,0,.1,1.194L6.986,8.647l-1,1L4.829,11.106l-1.289,2.1-1.785-.446a.783.783,0,0,0-.743,1.312L2.25,15.313l-.57.93a.783.783,0,0,0,1.079,1.074l.923-.571,1.242,1.242a.783.783,0,0,0,1.312-.743l-.451-1.8L7.9,14.138l1.413-1.124L17.25,5.07a2.47,2.47,0,0,0,.71-1.283A2.348,2.348,0,0,0,17.311,1.688Z"
            transform="translate(0 -1.002)"
          />
          <path
            id="Path_142"
            dataname="Path 142"
            d="M18,12.081,14.379,15.7l3.762,5.374a.783.783,0,0,0,.573.331q.032,0,.064,0a.782.782,0,0,0,.553-.229l.783-.783a.783.783,0,0,0,.195-.783Z"
            transform="translate(-3.127 -3.411)"
          />
        </g>
      </g>
    </svg>
  );
}
